/* <header-drawer>: the mobile menu on the shared drawer-dialog controller.
 * Sub-panels: a [data-drawer-level] trigger opens the panel it aria-controls
 * (data-open, inert off) and pushes it on a stack; [data-drawer-back] pops.
 * Only the top level is interactive: a panel covers its parent level, so the
 * parent's own head and list go inert while it is open and come back when it
 * is popped (Back, Escape or closing the dialog). Each panel head has its own
 * close button, so closing never needs a covered control.
 * Escape pops first and closes the dialog only from the root view. Focus
 * moves to the panel's back button and returns to the trigger on the way back. */
// Defined only with the shared controller in place: until then the snippet's <details> menu stays.
if (!customElements.get('header-drawer') && window.AsansaraDrawer) {
  customElements.define('header-drawer', class extends HTMLElement {
    connectedCallback() {
      this.events = new AbortController();
      const options = { signal: this.events.signal };
      const dialog = this.querySelector('dialog');
      this.drawer = new window.AsansaraDrawer(dialog, '[data-drawer-close]');
      this.stack = [];
      this.querySelector('[data-drawer-open]').addEventListener('click', (event) => this.drawer.open(event.currentTarget), options);
      this.addEventListener('click', (event) => {
        const trigger = event.target.closest('[data-drawer-level]');
        if (trigger) this.push(trigger);
        else if (event.target.closest('[data-drawer-back]')) this.pop();
      }, options);
      dialog.addEventListener('keydown', (event) => {
        if (event.key !== 'Escape' || !this.stack.length) return;
        event.preventDefault(); // no cancel event, so the dialog stays open
        this.pop();
      }, options);
      dialog.addEventListener('close', () => { while (this.stack.length) this.pop(false); }, options);
    }

    disconnectedCallback() {
      this.events.abort();
      this.drawer?.destroy();
    }

    push(trigger) {
      const panel = document.getElementById(trigger.getAttribute('aria-controls'));
      if (!panel) return;
      // The level under the panel: everything beside it in its parent except the sibling panels, which stay closed and inert.
      const covered = Array.from(panel.parentElement.children).filter((element) => !element.hasAttribute('data-drawer-panel'));
      trigger.setAttribute('aria-expanded', 'true');
      panel.setAttribute('data-open', '');
      panel.inert = false;
      this.stack.push({ trigger, panel, covered });
      panel.querySelector('[data-drawer-back]')?.focus({ preventScroll: true });
      covered.forEach((element) => { element.inert = true; });
    }

    pop(focus = true) {
      const level = this.stack.pop();
      if (!level) return;
      level.covered.forEach((element) => { element.inert = false; });
      level.trigger.setAttribute('aria-expanded', 'false');
      level.panel.removeAttribute('data-open');
      level.panel.inert = true;
      if (focus) level.trigger.focus({ preventScroll: true });
    }

    close() {
      this.drawer.close();
    }
  });
}
